import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h3 className="font-heading text-lg font-semibold text-background-50 mb-4">
              {t('site.name')}
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              {t('footer.quickLinks')}
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">{t('nav.home')}</Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-background-100 transition-colors">{t('nav.category')}</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">{t('nav.about')}</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              {t('footer.categories')}
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  {t(`nav.${cat.slug}`)}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              {t('footer.contactInfo')}
            </h4>
            <div className="flex flex-col gap-3">
              <span className="text-sm text-background-400">
                <i className="ri-mail-line mr-2"></i>{t('footer.email')}
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-phone-line mr-2"></i>{t('footer.phone')}
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-map-pin-line mr-2"></i>{t('footer.address')}
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-500">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}